import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_BUTTON_BACKGROUND,
  DARK_BUTTON_HOVER,
  DARK_CONTAINER_FIELDS_FLOATING,
  LIGHT_CONTAINER_FIELDS_FLOATING,
  PLAIN_TEXT,
} = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      gap: '1.5em',
      [theme.breakpoints.down(1260)]: {
        flexDirection: 'column',
      },
    },
    buttonCls: {
      height: '50px !important',
      borderRadius: 8,
      textTransform: 'unset',
      width: '100%',
      fontSize: 15,
    },
    backBtn: {
      background: DARK_BUTTON_BACKGROUND,
      color: PLAIN_TEXT,
      fontSize: 15,
      '&:hover': {
        background: DARK_BUTTON_HOVER,
      },
    },
    logoCls: {
      height: 'auto',
      width: '100%',
      maxWidth: 160,
      marginBottom: 20,
    },
    clearButton: {
      background: 'none',

      '&:hover': {
        background: 'none',
        opacity: 0.7,
      },
    },
    container: {
      background: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING,
      border: 'none',
      borderRadius: 8,
      padding: 20,
      width: '100%',
      position: 'relative',
      [theme.breakpoints.down('xs')]: {
        minHeight: '100%',
      },
    },
    information: {
      maxWidth: 500,
      height: '100%',
      width: 'auto',
      minWidth: 500,
      [theme.breakpoints.down(1260)]: {
        maxWidth: 'unset',
        minWidth: 'unset',
      },
    },
    body: {
      height: 'auto',
      [theme.breakpoints.down('md')]: {
        height: 'unset',
      },
    },
    completeBody: {
      padding: 35,
      [theme.breakpoints.down('xs')]: {
        padding: 20,
      },
    },
    header: {
      height: 50,
      display: 'flex',
      justifyContent: 'space-between',
      position: 'relative',
      alignItems: 'center',
      paddingBottom: 10,

      [theme.breakpoints.down(950)]: {
        flexDirection: 'column',
        paddingBottom: 60,
        alignItems: 'flex-start',
      },

      '&::before': {
        content: '""',
        background: 'none',
        height: '1px',
        position: 'absolute',
        width: '50px',
        bottom: '-1px',
      },
    },
    stepperContainer: {
      [theme.breakpoints.down(950)]: {
        marginTop: 15,
      },
    },
    footer: {
      position: 'absolute',
      display: 'flex',
      bottom: 30,
      width: '100%',
      gap: '1.5em',
      '& > div': {
        maxWidth: 320,
        width: '100%',
      },

      [theme.breakpoints.down('md')]: {
        position: 'unset',
        marginTop: 57,
      },

      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        gap: '0.5em',

        '& > div': {
          maxWidth: 'unset',
        },
      },
    },
  }),
);
